module.exports = __webpack_public_path__ + "img/logo_1.631494a6.png";